var $ = require("jquery");
var FontFaceObserver = require("fontfaceobserver");
var fileInput = require("bootstrap-fileinput");

// Compatibility
window.jQuery = $;

// detect font load
new FontFaceObserver("Lato")
	.load()
	.catch(function() {
		// Do nothing
	})
	.then(function() {
		var container = $(document.documentElement);
		container.addClass("wf-loaded");
	});

$(document).ready(function() {
	// Header dropdown
	(function() {
		$(".dropdown").on("click", ".dropdown__toggle", function(e) {
			if (
				$(this)
					.closest(".dropdown")
					.hasClass("active")
			) {
				$(".dropdown").removeClass("active");
			} else {
				$(".dropdown").removeClass("active");
				$(this)
					.closest(".dropdown")
					.addClass("active");
			}
		});
	})();

	(function() {
		$(".dropdown").on("click", ".dropdown__overlay", function(e) {
			$(".dropdown").removeClass("active");
		});
	})();

	// Tabs
	(function() {
		$(".tab").click(function(e) {
			e.preventDefault();
			var mypanel = $(this).attr("aria-controls");
			var type = $(this).attr("data-type");
			$(this).siblings(".tab").removeClass("active");
			$(this).addClass("active");
			$(".panel").removeClass("active");
			$("#" + mypanel).addClass("active");
			$("#TabShowing").val(type);
			enableEvidenceSave();
		});
	})();

	(function() {
		$(document).keypress(function(e) {
			if (e.which === 13 && $(".tab").is(":focus")) {
				e.preventDefault();
				var thisTab = $(".tab:focus");
				var mypanel = $(thisTab).attr("aria-controls");
				$(".tab").removeClass("active");
				$(thisTab).addClass("active");
				$(".panel").removeClass("active");
				$("#" + mypanel).addClass("active");
			}
		});
	})();

	// Accordion
	(function() {
		$(".accordion__header").click(function(e) {
			e.preventDefault();
			$(this)
				.parent()
				.toggleClass("active");
		});
	})();

	// Search bar
	(function() {
		$(".search-bar")
			.find(".btn--dropdown")
			.click(function(e) {
				e.preventDefault();
				$(this)
					.closest(".search-bar")
					.siblings(".search-filter")
					.toggleClass("active");
				$(this).toggleClass("active");
			});
	})();


	// modal close
	(function() {
		$(".modal__close").click(function(e) {
			e.preventDefault();
			$(this)
				.closest(".modal")
				.fadeOut();
		});
	})();

	(function() {
		$(".modal__overlay").click(function(e) {
			$(this)
				.closest(".modal")
				.fadeOut();
		});
	})();

	// Add items
	(function () {
		$(".btn--add").click(function (e) {
			e.preventDefault();
			console.log('add clicked');
			var id = $(this).attr("id");			
			var questionId = GetQuestionId(id);	
			var maxItems = $(this).siblings('.add__max').val();		
			if (maxItems !== undefined) {
				maxItems = parseInt(maxItems);
				// Offset zero indexing
				maxItems = maxItems - 1;
			}
			var addTextBox = $(this).siblings(".add__input");
			var addText = addTextBox.val();
			var addedItems = $(".added > div").length;

			var regex = new RegExp("^[a-zA-Z\\s0-9]+$");

			if ((addedItems <= maxItems) && (addText.length > 0) && regex.test(addText)) {
				$(this)
					.closest(".form-section")
					.find(".added")
					.append(
						`<div class='added__item'>
					<span>` +
							addText +
							`</span>
					<button class='added__remove'>
						<span>Remove Item</span>
					</button>
				</div>`
					);
				var answer = $(questionId).val();
				if (typeof answer === "undefined") {
					answer = addText;
				} else {
					answer += "~" + addText;
				}
				$(questionId).val(answer);
				addTextBox.val("");
			}
			if (addedItems >= maxItems && regex.test(addText)) {
				$(this).addClass("disabled");
				$(this).blur();
			}
		});
	})();

	(function() {
		$(document).keypress(function(e) {
			if (
				e.which === 13 &&
				$(".add__input").is(":focus") &&
				$(".add__input").val()
			) {
				e.preventDefault();
				var id = $(".btn--add").attr("id");
				var questionId = GetQuestionId(id);
				var maxItems = $(".btn--add").siblings(".add__max").val();
				if (maxItems !== undefined) {
					maxItems = parseInt(maxItems);
					// Offset zero indexing
					maxItems = maxItems - 1;
				}
				var addTextBox = $(".btn--add").siblings(".add__input");
				var addText = addTextBox.val();
				var addedItems = $(".added > div").length;
				var regex = new RegExp("^[a-zA-Z\\s0-9]+$");
				if (addedItems <= maxItems && addText.length && regex.test(addText)) {
					$(".btn--add")
						.closest(".form-section")
						.find(".added")
						.append(
							`<div class='added__item'>
					<span>` +
								addText +
								`</span>
					<button class='added__remove'>
						<span>Remove Item</span>
					</button>
				</div>`
						);
					var answer = $(questionId).val();
					if (typeof answer === "undefined") {
						answer = addText;
					} else {
						answer += "~" + addText;
					}
					$(questionId).val(answer);
					addTextBox.val("");
				}
				if (addedItems >= maxItems && regex.test(addText)) {
					$(".btn--add").addClass("disabled");
					$(".btn--add").blur();
				}
			}
		});
	})();

	// Remove items
	(function() {
		$(".added").on("click", ".added__remove", function(e) {
			e.preventDefault();
			var addButton = $(this)
				.closest(".form-group")
				.find(".btn--add");
			var questionId = GetQuestionId(addButton.attr("id"));
			var addedItem = $(this).closest(".added__item");
			var span = addedItem.children("span");
			var value = span.html();
			var answer = $(questionId).val();
			var valueToRemove = "~" + value;
			var indexOfValue = answer.indexOf(valueToRemove);
			// get value before removed entry
			var newAnswer = answer.substring(0, indexOfValue);
			answer = answer.substring(
				indexOfValue + valueToRemove.length,
				answer.length
			);
			// get the position of the next value
			indexOfValue = answer.indexOf("~");
			newAnswer += answer.substring(indexOfValue, answer.length);
			$(questionId).val(newAnswer);
			addedItem.remove();
			var addedItems = $(".added > div").length;
			var maxItems = $(".btn--add").siblings(".add__max").val();
				if (maxItems !== undefined) {
					maxItems = parseInt(maxItems);
					// Offset zero indexing
					maxItems = maxItems - 1;
				}
			if (addedItems <= maxItems) {
				addButton.removeClass("disabled");
			}
		});
	})();

	// Show / hide password
	(function() {
		$(".password-toggle").click(function(e) {
			e.preventDefault();
			var passInput = document.querySelector(".password");
			// var passInput = $('.password');
			if (passInput.type === "password") {
				passInput.type = "text";
				$(this).text("Hide password");
				$(".password-group").addClass("show-text");
			} else {
				passInput.type = "password";
				$(this).text("Show password");
				$(".password-group").removeClass("show-text");
			}
		});
	})();

	// Form errors
	(function() {
		$("body").on("click", ".btn--submit", function(e) {
			// Clean previous errors
			$(".form-group").removeClass("has-error");
			$(".form-error-text").remove();

			// Check for required elements
			$(".required").each(function() {
				// Required tag on input
				var myType = $(this).attr("type");
				var errorText = $(this).attr("data-error");
				if (myType && !$(this).val()) {
					e.preventDefault();
					errorRequired(this, errorText);
					// Required tag on fieldset - used for checkbox and radio
				} else if (
					$(this).find('input[type="radio"]').length &&
					!$(this).find('input[type="radio"]:checked').length
				) {
					e.preventDefault();
					errorRequired(this, errorText);
				} else if (
					$(this).find('input[type="checkbox"]').length &&
					!$(this).find('input[type="checkbox"]:checked').length
				) {
					e.preventDefault();
					errorRequired(this, errorText);
				}
			});

			// error only if one particular checkbox is selected on tis own
			$(".not-alone").each(function() {
				var errorText = $(this).attr("data-error");
				if ($(this).is(":checked") && !$(this).siblings(":checkbox:checked").length) {
					e.preventDefault();
					errorRequired(this, errorText);
				}
			});
		});
	})();
	// upload 
	(function () {
		$("body").on("click", ".btn--add-new-evidence", function (e) {
			// Clean previous errors
			$(".form-group").removeClass("has-error");
			$(".form-error-text").remove();
			var tabShowing = $("#TabShowing").val();
			// Check for URL elements
			if (tabShowing == "Link") {
				$(".check-url").each(function() {
					var regex = new RegExp(
						/^(http:\/\/www\.|https:\/\/www\.|http:\/\/|https:\/\/)?[a-z0-9]+([\-\.]{1}[a-z0-9]+)*\.[a-z]{2,5}(:[0-9]{1,5})?(\/.*)?$/);
					var errorText = $(this).attr("data-error");
					var urlText = $(this).val();
					if (!regex.test(urlText)) {
						e.preventDefault();
						errorRequired(this, errorText);
					}
				});
			}
		});
	})();
	// maxcharacter textarea
	(function() {
		$(".textarea-limited").each(function(item) {
			var text_max = $(this).attr("maxlength");
			var text_length = $(this).val().length;
			var text_name = $(this).attr("name");
			var span = $(this)
				.prev()
				.find("span.character-count");

			if (text_length === 0) {
				span.html(text_max);
			} else {
				span.html(text_max - text_length);
			}

			$(this).keyup(function() {
				var text_length = $(this).val().length;
				var text_remaining = text_max - text_length;

				span.html(text_remaining);
			});
		});
	})();
	
	// add evidence toggle input
	(function() {
		$(".add-evidence-switch").click(function(e) {
			e.preventDefault();
			$(this)
				.closest(".add-evidence__type")
				.toggle();
			$(this)
				.closest(".add-evidence__type")
				.siblings(".add-evidence__type")
				.toggle();
		});
	})();
});

(function () {
	$(".launch-edit").click(function (e) {
			e.preventDefault();
			var modalTarget = $(this).attr("data-target");
			var product = $(this).attr("data-product");
			var answer = $(this).attr("data-answer");
			var evidence = $(this).attr("data-evidence");
			$.get("/umbraco/Surface/EvidenceEditSurface/Index/", { productId: product, answerId: answer, evidenceId: evidence, targetId: modalTarget })
				.done(function (data) {
						$("#" + modalTarget).html(data);
					}, "html"
				);
			$("#" + modalTarget)
				// .css("display", "flex")
				.hide()
				.fadeIn()
		}
	)
})();

// checkbox limit
(function () {
	$('fieldset[data-limit]').each(function () {
		var limit = parseInt($(this).attr('data-limit'));
		var numChecked = 0;

		if (limit === '' || limit === undefined) {
			return false;
		}

		numChecked = $(this).find(':checkbox:checked').length; // onload
		if (limit !== 0 && numChecked > limit) {			
			$(this).find('p.limit-error-message').css('display', 'block');
			$(this).closest('.form-group').addClass('has-error');
			$('button[type=submit]').attr('disabled', 'disabled');
			$('button[type=submit]').toggleClass('disabled');
		}

		$(this).find(':checkbox').change(
			function () {				
				numChecked = $(this).parent().find(':checkbox:checked').length;
				
				// reset on change
				$(this).closest('fieldset[data-limit]').find('p.limit-error-message').css('display', 'none');
				$(this).closest('.form-group').removeClass('has-error');
				$('button[type=submit]').removeAttr('disabled');
				$('button[type=submit]').removeClass('disabled');
				if (limit !== 0 && numChecked > limit) {
					// show error
					$(this).closest('fieldset[data-limit]').find('p.limit-error-message').css('display', 'block');
					$(this).closest('.form-group').toggleClass('has-error');
					$('button[type=submit]').attr('disabled', 'disabled');
					$('button[type=submit]').toggleClass('disabled');
				}
			}
		);
	});
})();

// refactored data-triggers
// checks all fieldsets and .advisory-action elements for data-trigger attribute
(function () {
	var fields = ['fieldset', '.advisory-action'];
	fields.forEach(function (field) {
		$(field).each(function () {
			var triggerId = $(this).attr('data-triggers');
			var section = $(this);
			var hidePrevious = true;

			if (field === '.advisory-action') {
				hidePrevious = false;
			}

			if (triggerId !== undefined && triggerId.length > 0) {
				var trigger = getTrigger(triggerId);

				// check if checkbox or radio
				var type = getType(trigger);

				if (type === 'radio') {
					var radioGroup = trigger.attr('name');
					var val = $('input:radio[name="' + radioGroup + '"]:checked').val();
					var radioChecked = false;

					if (val === triggerId) {
						console.log('match');
						radioChecked = true;
					}

					showHideOnload(section, radioChecked, hidePrevious);
				}

				if (type === 'checkbox') {
					var checkboxChecked = trigger.is(':checked');
					showHideOnload(section, checkboxChecked, hidePrevious);
				}

				// find radio button matching trigger value
				mapTrigger(trigger, section, type, hidePrevious);
			}
		});
	});
})();

function TransferCompleteCallback (content) {
	// we might want to use the transferred content directly
	// for example to render an uploaded image
	console.log('all done');
}

function CheckFileSize (size) {
	var filesize = $('#FileSettings_MaxFileSize').val();
	var bytes = parseInt(filesize);

	if (size >= bytes) { // 5Mb in bytes
		return true;
	}
	return false;
}

function ClearFileInput (input) {
	// var clone = input.clone(true);
	// input.remove();
	// clone.val('');
	// $('#NewEvidence_File_Label').after(clone);
	// $('#NewEvidence_File').prop('disabled', false);

	input.val('');
	$('#NewEvidence_File').prop('disabled', false);
}

function ResetProgressBar (progressBar) {
	progressBar
		.css({ width: 10 + '%', background: '#5CA500' })
		.attr('aria-valuenow', 0)
		.text(0 + '%');
}

(function () {
	var formdata = false;

	if (window.FormData) {
		formdata = new FormData();
		// hide progress spinner
		$('#uploadProgress').hide();
	}

	$('#NewEvidence_File').on('change', function (event) {
		var progressBar = $('#uploadProgress .progressBar');
		var size = document.getElementById('NewEvidence_File').files[0].size;
		var fileName = document.getElementById('NewEvidence_File').files[0].name;
		var input = $('#NewEvidence_File');

		var fileError = $('#file-max-size-error');
		if ($(this).closest('.form-group').hasClass('has-error')) {
			// reset error
			$(this).closest('.form-group').toggleClass('has-error');
			fileError.remove();
			ResetProgressBar(progressBar);
		}

		var tooBig = CheckFileSize(size);
		if (tooBig) {
			// don't upload
			console.log('file is too big');
			$(this).closest('.form-group').toggleClass('has-error');

			progressBar
				.css({background: 'red', width: '100%'})
				.attr('aria-valuenow', 0)
				.text(fileName + ' is too big to upload');
			$('#uploadProgress').show();

			return;
		}

		var i = 0, len = this.files.length, img, reader, file;

		$('#result').html('');
		$('#NewEvidence_File').prop('disabled', true);

		$('#uploadProgress').show();
		for (i = 0; i < len; i++) {
			file = this.files[i];
			if (window.FileReader) {
				reader = new FileReader();
				reader.onloadend = function (e) {
					TransferCompleteCallback(e.target.result);
				};
				reader.readAsDataURL(file);
			}
			if (formdata) {
				formdata.append('files[]', file);
				formdata.append('productId', $('#ProductId').val());
			}
		}
		if (formdata) {
			$.ajax({
				xhr: function () {
					var xhr = new window.XMLHttpRequest();
					xhr.upload.addEventListener('progress', function (evt) {
						if (evt.lengthComputable) {
							console.log('progress calc');
							var percentComplete = evt.loaded / evt.total;
							// Do something with upload progress here
							console.log(Math.round(percentComplete * 100) + '%');
							var percentageRounded = Math.round(percentComplete * 100);
							progressBar
								.css({ width: percentageRounded + '%' })
								.attr('aria-valuenow', percentageRounded)
								.text(percentageRounded + '%');

							if (percentComplete === 1) {
								console.log('100% reached');

								progressBar
									.attr('aria-valuenow', percentageRounded)
									.text('Processing ' + fileName + ', please wait');
							}
						}
					}, false);

					xhr.addEventListener('progress', function (evt) {
						if (evt.lengthComputable) {
							var percentComplete = evt.loaded / evt.total;
							// Do something with download progress
							console.log(Math.round(percentComplete * 100) + '%');
							var percentageRounded = Math.round(percentComplete * 100);
							progressBar
								.css({ width: percentageRounded + '%' })
								.attr('aria-valuenow', percentageRounded)
								.text(percentageRounded + '%');
						}
					}, false);

					return xhr;
				},
				url: window.location.protocol + '//' + window.location.host + '/' + 'umbraco/api/Documents/Upload',
				type: 'POST',
				dataType: 'xml', // to support IE11, which doesn't support JSON response
				data: formdata,
				processData: false,
				contentType: false, // this is important!!!
				success: function (result) {
					progressBar.text(fileName + ' upload complete');

					var documentId = $(result).find('InitialPreviewConfig > InitialPreviewConfig:first-of-type Key').text();
					console.log(documentId);
					$('#NewEvidence_SelectedDocumentId').val('doc' + documentId);

					var removeButton = '<div class="input-group-btn">';
					removeButton 	+=	'<button type="button"id="uploadRemove" tabindex="500" title="Clear selected files" class="btn btn--secondary fileinput-remove fileinput-remove-button fileinput-remove fileinput-remove-button"> <span class="hidden-xs">Remove</span></button>';
					removeButton 	+= '</div>';

					$('#NewEvidence_File + .helper-text').after(removeButton);

					// reset formdata
					formdata = false;
					formdata = new FormData();
				},
				error: function (ex) {
					if (ex.status === 400) {
						console.log('bad request');
						progressBar
							.css({background: 'red', width: '100%'})
							.attr('aria-valuenow', 0)
							.text('File type not recognised');

						ClearFileInput(input);
					}
					else {
						progressBar
							.css({background: 'red', width: '100%'})
							.attr('aria-valuenow', 0)
							.text('File upload error');

						ClearFileInput(input);
						$('#NewEvidence_File').prop('disabled', false);
					}
				},
				complete: function () {
					setTimeout(function () {
						$('#uploadProgress').hide();
						ResetProgressBar(progressBar);
					}, 3000);

					enableEvidenceSave();
				}
			});
		}
		return false;
	});

	// File Delete
	$('#panel1').on('click', '#uploadRemove', function (event) {
		console.log('uploadRemove bindings');

		var progressBar = $('#uploadProgress .progressBar');
		var fileName = document.getElementById('NewEvidence_File').files[0].name;

		$('#uploadProgress').show();

		var selectedDoc = $('#NewEvidence_SelectedDocumentId').val();
		var documentId = selectedDoc.substring(3, selectedDoc.length); // removed doc prefix

		$.ajax({
			xhr: function () {
				var xhr = new window.XMLHttpRequest();
				xhr.upload.addEventListener('progress', function (evt) {
					if (evt.lengthComputable) {
						console.log('progress calc');
						var percentComplete = evt.loaded / evt.total;
						// Do something with upload progress here
						console.log(Math.round(percentComplete * 100) + '%');
						var percentageRounded = Math.round(percentComplete * 100);
						progressBar
							.css({ width: percentageRounded + '%' })
							.attr('aria-valuenow', percentageRounded)
							.text(percentageRounded + '%');

						if (percentComplete === 1) {
							console.log('100% reached');

							progressBar
								.attr('aria-valuenow', percentageRounded)
								.text('Deleting ' + fileName + ', please wait');
						}
					}
				}, false);

				xhr.addEventListener('progress', function (evt) {
					if (evt.lengthComputable) {
						var percentComplete = evt.loaded / evt.total;
						// Do something with download progress
						console.log(Math.round(percentComplete * 100) + '%');
						var percentageRounded = Math.round(percentComplete * 100);
						progressBar
							.css({ width: percentageRounded + '%' })
							.attr('aria-valuenow', percentageRounded)
							.text(percentageRounded + '%');
					}
				}, false);

				return xhr;
			},
			url: window.location.protocol + '//' + window.location.host + '/' + 'umbraco/api/Documents/DeleteFile',
			type: 'GET',
			data: {
				id: documentId
			},
			success: function (result) {
				progressBar.text(fileName + ' deleted');
				// clear file input
				var input = $('#NewEvidence_File');
				ClearFileInput(input);
				$('#NewEvidence_File').prop('disabled', false);
				$('#NewEvidence_SelectedDocumentId').val('');
				$('#uploadRemove').remove();
			},
			error: function (ex) {
				progressBar
					.css({background: 'red', width: '100%'})
					.attr('aria-valuenow', 0)
					.text('File deletion error');
			},
			complete: function () {
				setTimeout(function () {
					$('#uploadProgress').hide();
					ResetProgressBar(progressBar);
				}, 3000);

				enableEvidenceSave();
			}
		});
	});
})();

// modal open
(function () {
	$(".launch-remove").click(function (e) {
			e.preventDefault();
			var modalTarget = $(this).attr("data-target");
			var product = $(this).attr("data-product");
			var answer = $(this).attr("data-answer");
			var evidence = $(this).attr("data-evidence");
			$.get("/umbraco/Surface/EvidenceDeleteSurface/Confirm/", { productId: product, answerId: answer, evidenceId: evidence })
				.done(function (data) {
						$("#" + modalTarget).html(data);
					}, "html"
				);
			$("#" + modalTarget)
				// .css("display", "flex")
				.hide()
				.fadeIn()
		}
	)
})();

// evidencepage enable/disable button on change
(function () {
	$(".check-evidence-textbox").on('input propertychange paste', function () {
				enableEvidenceSave();
			}
		)
})();
(function () {
	$(".check-evidence-dropdown").change(function () {
			enableEvidenceSave();
		}
	)
})();
(function() {
	$(".check-evidence-checkbox").change(function() {
			enableEvidenceSave();
		}
	)
})();
(function() {
	$(".check-evidence-url").on('input propertychange paste',
		(function() {
				enableEvidenceSave();
			}
		)
	)
})();
(function() {
	$(".check-evidence-radio").change(function () {
			enableEvidenceSave();
		}
	)
})();
function enableEvidenceSave() {
	var enableEvidence = false;
	$(".check-evidence-textbox").each(function() {
		if ($(this).val().length > 0) {
				enableEvidence = true;
			}
		}
	);
	if (!enableEvidence) {
		$(".check-evidence-dropdown").each(function () {
				if ($(this).val() != "-1" && $(this).val() != "0") {
					enableEvidence = true;
				}
			}
		);
	}
	if (!enableEvidence) {
		$(".check-evidence-checkbox").each(function () {
			if ($(this).is(":checked")) {
					enableEvidence = true;
				}
			}
		);
	}
	
	if (!enableEvidence) {
		var tabshowing = $("#TabShowing").val();
		switch(tabshowing) {
			case "UploadFile":
				enableEvidence = UploadFileIsValidForSave();
				break;
			case "Link":
				enableEvidence = LinkIsValidForSave();
				break;
			case "AttachedFile":
				enableEvidence = true;
				break;
			case "PreviouslyUploaded":
				enableEvidence = PreviouslyUploadedIsValidForSave();
				break;
		}
	}
	var addButton = $("#addMore");
	if (enableEvidence) {
		addButton.removeClass("disabled");
	} else {
		addButton.addClass("disabled");
	}
}
function UploadFileIsValidForSave() {
	var uploadedId = $("#NewEvidence_SelectedDocumentId").val();
	return uploadedId.length>true;
}
function LinkIsValidForSave() {
	var valid = false;
	$(".check-evidence-url").each(function () {
		if ($(this).val().length > 0) {
			valid= true;
			}
		}
	);
	return valid;
}
function PreviouslyUploadedIsValidForSave() {
	var valid = false;
	$(".check-evidence-radio").each(function () {
			if ($(this).is(":checked")) {
				valid = true;
			}
		}
	);
	return valid;
}
function showHideOnload (section, isChecked, hidePrevious) {
	if (hidePrevious === undefined) {
		hidePrevious = true;
	}

	// if not checked hide section and label
	if (!isChecked) {
		console.log('not checked');
		section.hide();
		if (hidePrevious) {
			section.prev().hide();
		}
	}
	else {
		console.log('checked');
		section.show();
		if (hidePrevious) {
			section.prev().show();
		}		
	}
}

function clearRadio (radio) {
	radio.attr('checked', false);
}

function getType (trigger) {
	var type = '';

	if ($(trigger).is(':checkbox')) {
		console.log('is checkbox');
		type = 'checkbox';
	}
	else {
		console.log('is radio');
		type = 'radio';
	}

	return type;
}

function getTrigger (triggerId) {
	var trigger = $('#' + triggerId);
	return trigger;
}

function mapTrigger (trigger, section, type, hidePrevious) {
	if (hidePrevious === undefined) {
		hidePrevious = true;
	}

	if (type === 'radio') {
		var radioGroup = trigger.attr('name');

		console.log(radioGroup);

		$('input:radio[name="' + radioGroup + '"]').change(
			function () {
				if ($(this).is(':checked')) { // check if the radio is checked
					var val = $(this).val(); // retrieve the value
					var radioChecked = false;

					if (val === trigger.attr('id')) {
						radioChecked = true;
						showHideOnload(section, radioChecked, hidePrevious);
					}
					else {
						showHideOnload(section, radioChecked, hidePrevious);
						clearRadio(section.find(':radio'));
						console.log('clear select')
						section.find('select').val('');
					}
				}
			}
		);
	}

	if (type === 'checkbox') {
		$('input:checkbox[id="' + trigger.attr('id') + '"]').change(
			function () {
				var isChecked = $(this).is(':checked');
				showHideOnload(section, isChecked, hidePrevious);
				if (!isChecked) {
					clearRadio(section.find(':radio'));
					console.log('clear select')
					section.find('select').val('');
					console.log('is radio still checked ' + section.find(':radio').is(':checked'));
				}
			}
		);
	}
}

function errorRequired(input, errorText) {
	$(input)
		.closest(".form-group")
		.addClass("has-error");
	$(input)
		.closest(".form-group")
		.append(`<span class='form-error-text'>` + errorText + `</span>`);
	scrollToError();
}

function scrollToError() {
	$("html, body").animate(
		{
			scrollTop: $(".has-error:first").offset().top
		},
		1000
	);
}

function GetQuestionId(id) {
	if (id != undefined) {
		var n = id.indexOf("].");
		id = id.substring(3, n + 2) + "Answer";
		id = id.replace("[", "_");
		id = id.replace("]", "_");
		id = "#" + id.replace(".", "_");
		return id;
	}
}



// WEBPACK FOOTER //
// ./app/assets/js/scripts.js